import { getRolePath } from "../../utils/common";
import { markNewTabOpening } from "../../utils/tabHeartbeat";

export function getRevenueRowEmployeeIds(row = {}) {
  if (row.managerId != null && row.managerId !== "") {
    const ids = new Set([String(row.managerId)]);
    (row.children || []).forEach((child) => {
      if (child?.employee_id != null && child.employee_id !== "") {
        ids.add(String(child.employee_id));
      }
    });
    return Array.from(ids);
  }

  if (row.employee_id != null && row.employee_id !== "") {
    return [String(row.employee_id)];
  }

  return [];
}

function appendRevenueEmployeeAndDates(params, row, dateFilters = {}) {
  const employeeIds = getRevenueRowEmployeeIds(row);
  if (employeeIds.length) {
    params.set("employee_ids", employeeIds.join(","));
  }
  if (dateFilters.start_date) {
    params.set("start_date", dateFilters.start_date);
  }
  if (dateFilters.end_date) {
    params.set("end_date", dateFilters.end_date);
  }
  return params;
}

function openReportTab(path) {
  markNewTabOpening();
  const url = path.startsWith("http")
    ? path
    : `${window.location.origin}${path}`;
  window.open(url, "_blank");
}

/** URL for opening pending invoices in a new tab (query params survive new-tab navigation). */
export function buildRevenuePendingInvoicesUrl(row, dateFilters = {}) {
  const params = new URLSearchParams();

  params.set("filterStatus", "Pending");
  params.set("listOnly", "true");
  params.set("sort", "asc");
  appendRevenueEmployeeAndDates(params, row, dateFilters);

  return `${getRolePath("/invoice_contract")}?${params.toString()}`;
}

/** Paid invoices counted as No. of Payments Done (status 1, billed by that employee). */
export function buildRevenuePaidInvoicesUrl(row, dateFilters = {}) {
  const params = new URLSearchParams();

  params.set("listOnly", "true");
  params.set("sort", "asc");
  params.set("rawStatus", "1");
  params.set("billed_by_only", "true");
  appendRevenueEmployeeAndDates(params, row, dateFilters);

  return `${getRolePath("/invoice_contract")}?${params.toString()}`;
}

/** Active clients counted as No. of Customers for that employee. */
export function buildRevenueCustomersUrl(row) {
  const params = new URLSearchParams();
  const employeeIds = getRevenueRowEmployeeIds(row);
  if (employeeIds.length) {
    params.set("revenue_employee_ids", employeeIds.join(","));
  }
  return `${getRolePath("/client")}?${params.toString()}`;
}

/** Navigation state for same-tab navigation (optional). */
export function buildRevenuePendingInvoicesNavState(row, dateFilters = {}) {
  const employeeIds = getRevenueRowEmployeeIds(row);
  const state = {
    mode: "invoice",
    listOnly: true,
    filterStatus: "Pending",
    sortOrder: "asc",
  };

  if (employeeIds.length) {
    state.employeeIds = employeeIds;
  }
  if (dateFilters.start_date) {
    state.start_date = dateFilters.start_date;
  }
  if (dateFilters.end_date) {
    state.end_date = dateFilters.end_date;
  }

  return state;
}

export function openRevenuePendingInvoicesTab(row, dateFilters = {}) {
  openReportTab(buildRevenuePendingInvoicesUrl(row, dateFilters));
}

export function openRevenuePaidInvoicesTab(row, dateFilters = {}) {
  openReportTab(buildRevenuePaidInvoicesUrl(row, dateFilters));
}

export function openRevenueCustomersTab(row) {
  openReportTab(buildRevenueCustomersUrl(row));
}
